import React from 'react';
import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';
import styles from './keto-merch.module.css';
import { Container } from '../../components';

export default function KetoMerch() {
  return (
    <section className={styles.merch}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.merch_inner}
        >
          <KetoTypography
            className={styles.merch_title}
            variant={KetoTypographyVariant.HEADLINE_1}
            tag="h2"
          >
            Merch
          </KetoTypography>
          <Image
            alt="keto kitchen merch"
            src="/keto/merch/merch.png"
            width={1180}
            height={975}
          />
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
